import React, { useEffect } from "react";
// import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
// import Typography from "@material-ui/core/Typography";
import { Button, Input, Text, SelectBox } from "sunrise-ui";
import PopOverProps from "./PopOver.types";
import "./PopOver.scss";

const PopOver = ({
  anchor,
  label,
  type,
  value,
  button,
  sendValue,
  inputUpdate,
  editType,
  machineArray,
  setHeader,
  machineParts,
  selectedMachine,
  selectedHmrReading,
  selectedMachinePart,
}: PopOverProps) => {
  // const classes = useStyles();
  const [anchorEl, setAnchorEl] =
    React.useState<HTMLButtonElement | null>(null);
  const [inputLabel, setInputLabel] = React.useState("");
  const [masterType, setMasterType] = React.useState("");
  const [btn, setBtn] = React.useState(false);
  const [inputError, setInputError] = React.useState(false);
  const [inputValue, setInputValue] = React.useState("");
  const [machinePart, setMachinePart] = React.useState("");
  const [hmrReading, setHmrReading] = React.useState("");
  const [hmrMachinePart, setHmrMachinePart] = React.useState("");

  const [machinePartError, setMachinePartError] = React.useState(false);
  const [hmrReadingError, setHmrReadingError] = React.useState(false);
  const [hmrMachinePartError, setHmrMachinePartError] = React.useState(false);

  const [machineList, setMachineList] = React.useState([]);
  const [machinePartsList, setMachinePartsList] = React.useState([]);

  //default machine value during item edit .........
  useEffect(() => {
    setMachinePartsList(machineParts);
    setHmrMachinePart(selectedMachinePart);
    // eslint-disable-next-line
  }, [machineParts]);

  useEffect(() => {
    setMachinePart(selectedMachinePart);
  }, [selectedMachinePart]);

  useEffect(() => {
    setHmrReading(selectedHmrReading);
  }, [selectedHmrReading]);
  // end.................

  useEffect(() => {
    setBtn(button);
  }, [button]);

  //machine list array for the dropdown
  useEffect(() => {
    setMachineList(machineArray);
    setInputValue(value);
    // eslint-disable-next-line
  }, [machineArray]);

  useEffect(() => {
    setInputLabel(label);
  }, [label]);

  useEffect(() => {
    setMasterType(type);
  }, [type]);

  useEffect(() => {
    if (editType !== "" && editType?.length > 0) setMasterType(editType);
    else setMasterType("");
  }, [editType]);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setInputError(false);
    setHeader();
    // btnClick();
  };

  useEffect(() => {
    if (inputValue?.length > 0) {
      inputUpdate(inputValue);
    }
    // eslint-disable-next-line
  }, [inputValue]);

  const handleClose = () => {
    setAnchorEl(null);
    //resetting variables to their inital state when popup closes
    if (type.includes("Add")) {
      setInputValue("");
      setMachinePart("");
      setHmrMachinePart("");
      setHmrReading("");
      setMachinePartError(false);
      setHmrMachinePartError(false);
      setHmrReadingError(false);
    }
    // setInputValue("");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const submitInputField = () => {
    if (
      masterType !== "Add New Machine-part Type" &&
      masterType !== "Add New Hmr-reading Type"
    ) {
      if (inputValue === undefined || inputValue.length === 0) {
        setInputError(true);
      } else {
        setInputError(false);
      }
      if (inputValue.length > 0) {
        sendValue(inputValue);
        handleClose();
      }
    }

    if (
      masterType === "Add New Machine-part Type" ||
      masterType === "machine-part"
    ) {
      if (inputValue === undefined || inputValue?.length === 0) {
        setInputError(true);
      } else {
        setInputError(false);
      }
      if (machinePart === undefined || machinePart?.length === 0) {
        setMachinePartError(true);
      } else {
        setMachinePartError(false);
      }
      if (inputValue?.length > 0 && machinePart?.length > 0) {
        let obj = {
          machineType: inputValue,
          machinePart: machinePart,
        };
        sendValue(obj);
        handleClose();
      }
    }

    if (
      masterType === "Add New Hmr-reading Type" ||
      masterType === "hmr-reading"
    ) {
      if (inputValue === undefined || inputValue?.length === 0) {
        setInputError(true);
      } else {
        setInputError(false);
      }
      if (hmrMachinePart === undefined || hmrMachinePart?.length === 0) {
        setHmrMachinePartError(true);
      } else {
        setHmrMachinePartError(false);
      }
      if (hmrReading === undefined || hmrReading.toString()?.length === 0) {
        setHmrReadingError(true);
      } else {
        setHmrReadingError(false);
      }
      if (
        inputValue?.length > 0 &&
        hmrMachinePart?.length > 0 &&
        hmrReading.toString()?.length > 0
      ) {
        let obj = {
          machineType: inputValue,
          machinePart: hmrMachinePart,
          hmrReading: hmrReading,
        };
        sendValue(obj);
        handleClose();
      }
    }
  };

  //so field is requried if input length === 0 method
  const checkLength = (data: any) => {
    if (data.length > 0) {
      setInputError(false);
    } else {
      setInputError(true);
    }
  };

  //so field is requried if input length === 0 method
  const checkMPLength = (data: any) => {
    if (data.length > 0) {
      setMachinePartError(false);
    } else {
      setMachinePartError(true);
    }
  };

  //so field is requried if input length === 0 method
  const checkHMRLength = (data: any) => {
    if (data.length > 0) {
      setHmrReadingError(false);
    } else {
      setHmrReadingError(true);
    }
  };
  return (
    <>
      <div onClick={(e: any) => handleClick(e)}>
        {btn ? (
          <span
            className="iconify"
            data-icon="clarity:edit-line"
            data-width="20"
            data-height="20"
            style={{ color: "#5F67E0" }}
          ></span>
        ) : (
          <Button
            style={{
              width: "96px",
              fontSize: "14px",
              height: "1.5rem",
            }}
            type="button"
            isRounded={true}
            // onClick={() => addType()}
          >
            <span className="iconify" data-icon="carbon:add"></span>
            Add New
          </Button>
        )}
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <>
          <div className="pop">
            {masterType !== "Add New Machine-part Type" &&
            masterType !== "Add New Hmr-reading Type" ? (
              <div>
                <div className="fw-500 fs-14">{masterType}</div>
                <div className="flex jc-sb mt-1">
                  <label className="fw-500 fs-14">{inputLabel}</label> &nbsp;
                  <Input
                    type="text"
                    color={inputError ? "danger" : "primary"}
                    className="height2 w-160"
                    value={inputValue}
                    onChange={(e: any) => {
                      setInputValue(e.target.value);
                      checkLength(e.target.value);
                      if (e.target.value.length > 0) {
                        setInputError(false);
                      } else {
                        setInputError(true);
                      }
                    }}
                  ></Input>
                </div>
                {inputError && (
                  <Text
                    type={`${inputError ? "danger" : "normal"}`}
                    fonts="normal"
                    fontSize={12}
                    className={`mt0 mb0 pb0 d-flex h-end padding`}
                  >
                    This field is required
                  </Text>
                )}
              </div>
            ) : (
              <div>
                <div className="fw-500 fs-14">{masterType}</div>
                <div className="flex jc-sb mt-1">
                  <label className="fw-500 fs-14">Machine Type</label> &nbsp;
                  <div style={{ width: "10rem" }}>
                    <SelectBox
                      type="text"
                      data={machineList}
                      borderColor={inputError ? "danger" : "primary"}
                      value={inputValue}
                      defaultVal={inputValue}
                      placeHolder="Select Machine"
                      // placeholder="Select Machine"
                      onChange={(e: any) => {
                        setInputValue(e.target.value);
                        checkLength(e.target.value);
                        selectedMachine(e.target.value);
                        if (e.target.value.length > 0) {
                          setInputError(false);
                        } else {
                          setInputError(true);
                        }
                      }}
                    ></SelectBox>
                  </div>
                </div>
                {inputError && (
                  <Text
                    type={`${inputError ? "danger" : "normal"}`}
                    fonts="normal"
                    fontSize={12}
                    className={`mt0 mb0 pb0 d-flex h-end padding`}
                  >
                    This field is required
                  </Text>
                )}
                {/* //if mastertype machine-part */}
                {masterType === "Add New Machine-part Type" ? (
                  <>
                    <div className="flex jc-sb mt-1">
                      <label className="fw-500 fs-14">Machine Parts</label>{" "}
                      &nbsp;
                      <Input
                        type="text"
                        color={machinePartError ? "danger" : "primary"}
                        className="height2-5 w-160"
                        value={machinePart}
                        placeholder="Select Machine Part"
                        onChange={(e: any) => {
                          setMachinePart(e.target.value);
                          checkMPLength(e.target.value);
                          if (e.target.value.length > 0) {
                            setMachinePartError(false);
                          } else {
                            setMachinePartError(true);
                          }
                        }}
                      ></Input>
                    </div>
                    {machinePartError && (
                      <Text
                        type={`${machinePartError ? "danger" : "normal"}`}
                        fonts="normal"
                        fontSize={12}
                        className={`mt0 mb0 pb0 d-flex h-end padding`}
                      >
                        This field is required
                      </Text>
                    )}
                  </>
                ) : (
                  //  master data type in hmr-reading
                  <div className="flex jc-sb">
                    <label className="fw-500 fs-14">Machinery Parts</label>{" "}
                    &nbsp;
                    <div style={{ width: "10rem" }}>
                      <SelectBox
                        type="text"
                        data={machinePartsList}
                        borderColor={hmrMachinePartError ? "danger" : "primary"}
                        value={hmrMachinePart}
                        defaultVal={hmrMachinePart}
                        placeHolder="Select Part"
                        onChange={(e: any) => {
                          setHmrMachinePart(e.target.value);
                          checkLength(e.target.value);
                          if (e.target.value.length > 0) {
                            setHmrMachinePartError(false);
                          } else {
                            setHmrMachinePartError(true);
                          }
                        }}
                      ></SelectBox>
                    </div>
                  </div>
                )}
                {hmrMachinePartError && (
                  <Text
                    type={`${hmrMachinePartError ? "danger" : "normal"}`}
                    fonts="normal"
                    fontSize={12}
                    className={`mt-0 float-r mb0 pb0 d-flex h-end padding`}
                  >
                    This field is required
                  </Text>
                )}
                {masterType === "Add New Hmr-reading Type" && (
                  <div>
                    <div className="flex jc-sb mt-1 w100">
                      <label className="fw-500 fs-14">Hmr reading</label> &nbsp;
                      <Input
                        type="text"
                        color={hmrReadingError ? "danger" : "primary"}
                        className="height2-5 w-160"
                        value={hmrReading}
                        placeholder="HMR Reading"
                        onChange={(e: any) => {
                          setHmrReading(e.target.value);
                          checkHMRLength(e.target.value);
                          if (e.target.value.length > 0) {
                            setHmrReadingError(false);
                          } else {
                            setHmrReadingError(true);
                          }
                        }}
                      ></Input>
                    </div>
                    {hmrReadingError && (
                      <Text
                        type={`${hmrReadingError ? "danger" : "normal"}`}
                        fonts="normal"
                        fontSize={12}
                        className={`mt-0 float-r mb0 pb0 d-flex h-end padding`}
                      >
                        This field is required
                      </Text>
                    )}
                  </div>
                )}
              </div>
            )}
            <div className="flex jc-e py-1 float-r w-100">
              <Button
                category="border-only"
                type="button"
                color="primary"
                isRounded={true}
                size="small"
                className="btnWidth"
                onClick={() => handleClose()}
              >
                Cancel
              </Button>
              <Button
                category="primary"
                type="button"
                color="primary"
                isRounded={true}
                size="small"
                className="btnWidth ml-1"
                onClick={() => submitInputField()}
              >
                Submit
              </Button>
            </div>
          </div>
        </>
      </Popover>
    </>
  );
};

export default PopOver;
